/*
 * @Description: 推广管理通用数据管理
 * @Author: yanzhigen@batmobi.net
 * @Date: 2018-11-15 10:59:22
 * @LastEditors: shuisheng
 * @LastEditTime: 2022-08-11 11:31:39
 */

export default {
    state: {
        statusValue: {
            series: {
                '': '全部',
                '0,1,4': '未归档',
                '12': '已开启',
                '0': '已停止',
                '11': '未开始',
                '13': '已结束',
                '4': '超预算',
                '3': '已归档',
            },
            campaign: {
                '': '全部',
                '0,1,4': '未归档',
                '1': '已开启',
                '0': '已停止',
                '4': '超预算',
                '3': '已归档',
            },
            creative: {
                // "0,1,4,5,6": "有效推广",
                '': '全部',
                '0,1': '未归档',
                '1': '已开启',
                '0': '已停止',
                '3': '已归档',
            },
        },
        dropdownStatusValue: {
            '': '全部',
            '0': '未投放',
            '1': '投放中',
        },
        offerBundleStatusValue: {
            '': '全部',
            '0': '下线',
            '1': '在线',
        },
        statusList: {
            series: [
                { name: '', value: '全部' },
                { name: '0,1,4', value: '未归档' },
                { name: '12', value: '已开启' },
                { name: '0', value: '已停止' },
                { name: '11', value: '未开始' },
                { name: '13', value: '已结束' },
                { name: '4', value: '超预算' },
                { name: '3', value: '已归档' },
            ],
            campaign: [
                { name: '', value: '全部' },
                { name: '0,1,4', value: '未归档' },
                { name: '1', value: '已开启' },
                { name: '0', value: '已停止' },
                { name: '4', value: '超预算' },
                { name: '3', value: '已归档' },
            ],
            creative: [
                { name: '', value: '全部' },
                { name: '0,1', value: '未归档' },
                { name: '1', value: '已开启' },
                { name: '0', value: '已停止' },
                { name: '3', value: '已归档' },
            ],
        },
        adminstatusList:[
            { name: '', value: '全部' },
            { name: '1', value: '开启' },
            { name: '0', value: '关闭' },
        ],
        adminstatusValue:{
            '': '全部',
            '1': '开启',
            '0': '关闭',
        },

        dropdownStatusList: [
            { name: '', value: '全部' },
            { name: '1', value: '投放中' },
            { name: '0', value: '未投放' },
        ],
        // dropdownStatusList: [
        //     { name: '', value: '全部' },
        //     { name: '1', value: '投放中' },
        //     { name: '0', value: '未投放' },
        // ],
        offerBundleStatusList: [
            { name: '', value: '全部' },
            { name: '1', value: '在线' },
            { name: '0', value: '下线' },
        ],
        //批量操作类型数组
        statusText: ['审核中', '全部通过', '全部拒绝'],
        statusColor: ['#ef9051', '#23c52f', '#fd5f65'],
    },
    mutations: {},
};



// WEBPACK FOOTER //
// ./src/store/promotionManagement.js